export default `
  <form class="site-header-search">
    <div class="search-input-container">
        <span class="icon-search"></span>
        <input type="text" placeholder="Search Rapyd Docs" maxlength="30" class="form-control search-field" id="search-bar">
        <span class="icon-delete"></span>
    </div>
    <div class="search-dropdown">
        <ul class="search-results"></ul>
    </div>
  </form>
`;
